export default {"src":"/_next/static/media/link.0f0522a5.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};